import { registerSymbol } from "library/serialize-circular.mjs"
import { PlanRoot } from "library/tree/constants.mjs"
const parentTreeItem = registerSymbol(Symbol("parent"))
const Hide = registerSymbol(Symbol("Hide"))
const TreeRoot = registerSymbol(Symbol("TreeRoot"))
const parentSome = (item, predicate = () => false) => {
    if (!item) return false
    if (predicate(item)) {
        return true
    }
    if (!item[TreeRoot]) {
        return parentSome(item?.[parentTreeItem], predicate)
    }
    return false
}
const parentFind = (item, predicate = () => false, seen = new Set(), depth = 0) => {
    if (!item) return null
    if (seen.has(item)) return null
    if (depth > 30) return null
    seen.add(item)
    return predicate(item) ? item : parentFind(item?.[parentTreeItem], predicate, seen, depth + 1)
}
const allParents = (item, check = (item) => !!item[parentTreeItem], list = [], seen = new Set()) => {
    if (!item) return list
    if (seen.has(item)) return list
    seen.add(item)
    list.push(item)
    if (!check(item)) return list
    return allParents(item[parentTreeItem], check, list, seen)
}
const findInChildren = (item, predicate = () => false, depth = Infinity) => {
    if (!item) return []
    return find(item)
    function find(item, output = [], current = 0) {
        if (predicate(item)) {
            output.push(item)
        }
        if (item.children?.length && current < depth) {
            for (const child of item.children) {
                find(child, output, current + 1)
            }
        }
        return output
    }
}
function getWhere(currentGroup) {
    return getParents(currentGroup).reverse().map("label").join(" › ")
}
function getParents(currentGroup) {
    const parents = []
    while (currentGroup && currentGroup.data?.type !== "facility" && !currentGroup[PlanRoot]) {
        parents.push({
            label: currentGroup.label,
            id: currentGroup.id,
        })
        currentGroup = currentGroup[parentTreeItem]
    }
    if (currentGroup && !currentGroup[PlanRoot]) {
        parents.push({
            label: currentGroup.label,
            id: currentGroup.id,
        })
    }
    return parents
}
function getAllParents(currentGroup) {
    const parents = []
    while (currentGroup) {
        parents.push({
            label: currentGroup.label,
            id: currentGroup.id,
        })
        currentGroup = currentGroup[parentTreeItem]
    }
    return parents
}
export { Hide }
export { TreeRoot }
export { parentTreeItem }
export { parentSome }
export { parentFind }
export { allParents }
export { findInChildren }
export { getWhere }
export { getParents }
export { getAllParents }
